// Static video data from vimeo.com/toaststudiotv (pre-fetched via oEmbed API)
// Generated on 2026-02-12 — 140 videos (duplicates & test removed)

export interface VimeoItem {
  id: number;
  title: string;
  thumbnail_large: string;
  url: string;
}

export const ALL_VIDEOS: VimeoItem[] = [
  {
    "id": 1148403657,
    "title": "YS_SmartCity_Transport (Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2098584932-4ebb1fa66b7ff987f969e9d08715c88f23f704195aaced280a64a5227765ee04-d_640x360?region=us",
    "url": "https://vimeo.com/1148403657"
  },
  {
    "id": 1148403436,
    "title": "YS_SmartCity_Simulation (Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2098584583-74fd4cd8b80ea9d06334a93f3202e93f341c219174145f12ada613612af72977-d_640x360?region=us",
    "url": "https://vimeo.com/1148403436"
  },
  {
    "id": 1148402295,
    "title": "YS_SmartCity_DT (Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2098582875-a226329c809a1005ffce799344030f2149a0ad67082025de02337600e8547279-d_640x360?region=us",
    "url": "https://vimeo.com/1148402295"
  },
  {
    "id": 1148402160,
    "title": "나의 나라 | 오프닝 타이틀",
    "thumbnail_large": "https://i.vimeocdn.com/video/2098582445-0cccf091cb4a81dab952499b79bc086fc8370bab44e4758d7303176943a97632-d_640x360?region=us",
    "url": "https://vimeo.com/1148402160"
  },
  {
    "id": 1148402083,
    "title": "YS_SmartCity (Fin1000)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2098582612-9741c5719cba87064146320db9f99c3e6e81a6e65a149b009af713d003688dd9-d_640x360?region=us",
    "url": "https://vimeo.com/1148402083"
  },
  {
    "id": 1148401819,
    "title": "Toast_Motion_Reels_2025",
    "thumbnail_large": "https://i.vimeocdn.com/video/2098582164-ee04b116c2b918730c70235a599cf0c6e4fde3d7117b75be1de1dfa81166b6bd-d_640x360?region=us",
    "url": "https://vimeo.com/1148401819"
  },
  {
    "id": 1135597363,
    "title": "00_KPA_수업전_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080969032-5b97a4f0fa87ded3669b88ebd963fcb4a44ca4895d55573e4ee56c34d09b7f28-d_640x360?region=us",
    "url": "https://vimeo.com/1135597363"
  },
  {
    "id": 1135595228,
    "title": "KPA_Lesson2_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080966144-2336f8f738d359276487a411e6defeb349071fe071bbb476c14809696cec5b51-d_640x360?region=us",
    "url": "https://vimeo.com/1135595228"
  },
  {
    "id": 1135594609,
    "title": "KPA_02_수정본_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080966206-7634d8b2f3939ceac152d69bff3f50a19095cd8c8e2ec645c8e2e6eb87697a08-d_640x360?region=us",
    "url": "https://vimeo.com/1135594609"
  },
  {
    "id": 1135321084,
    "title": "사전테스트_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080613218-693d81a664dfcdf0e899bf31692f03e35d4cf4ecdc77bbaf3cf1470855f41c17-d_640x360?region=us",
    "url": "https://vimeo.com/1135321084"
  },
  {
    "id": 1135154067,
    "title": "KPA_11_교육종료_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080396351-9caff4dd6974944b18b6ef9559467a8c993d2b9d9fc10f472ac3cba05443dd2e-d_640x360?region=us",
    "url": "https://vimeo.com/1135154067"
  },
  {
    "id": 1135153546,
    "title": "점심시간_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080395325-1a968c19e5e6db9c2375837679be1071af7baedfc75f304b440bbddfa7f68ab2-d_640x360?region=us",
    "url": "https://vimeo.com/1135153546"
  },
  {
    "id": 1135152803,
    "title": "KPA_09_쉬는시간_최종",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080394378-11c3c727b6c928565b6d2ef667da65cb5ce91293902f9439dd16919c25ee6fbc-d_640x360?region=us",
    "url": "https://vimeo.com/1135152803"
  },
  {
    "id": 1135020847,
    "title": "1108_KPA_01_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080211357-59b74d2e3a81c93a383e4bc2e17624103932651fda0b7ea289fae5d987992c7c-d_640x360?region=us",
    "url": "https://vimeo.com/1135020847"
  },
  {
    "id": 1135020310,
    "title": "1108_KPA_04_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080210457-9c126cdaee3a4db452d8f7b953582a6e154dc1a6a0a9e1497239e3584d65f151-d_640x360?region=us",
    "url": "https://vimeo.com/1135020310"
  },
  {
    "id": 1135019782,
    "title": "1108_KPA_08_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080209690-520b33d92d063854de40c501b252c5f0cbced43ae54f3c67422496a374612ed4-d_640x360?region=us",
    "url": "https://vimeo.com/1135019782"
  },
  {
    "id": 1135019259,
    "title": "1108_KPA_05_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080208936-89d00cca314c776df68eafd5df164d715355c113ac224e901a5f615791519d9c-d_640x360?region=us",
    "url": "https://vimeo.com/1135019259"
  },
  {
    "id": 1135018732,
    "title": "1108_KPA_06_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080208223-eba49bb72c5e66367845e9becaa2efa52adff1f03e46cecec30072469ca14278-d_640x360?region=us",
    "url": "https://vimeo.com/1135018732"
  },
  {
    "id": 1135018245,
    "title": "1108_KPA_07_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080207495-4cec3f89664abbe249d80d1b09cc0ab9276d4a5932a1af5920e0a76ae22b0ed0-d_640x360?region=us",
    "url": "https://vimeo.com/1135018245"
  },
  {
    "id": 1135017751,
    "title": "1108_KPA_03_수정본",
    "thumbnail_large": "https://i.vimeocdn.com/video/2080206694-68f6146a9687ad9a4cf4f1e64375369c64f9f4bbd9064f636c940d13846ce920-d_640x360?region=us",
    "url": "https://vimeo.com/1135017751"
  },
  {
    "id": 1133357728,
    "title": "1103_KPA_Lesson8",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077928786-7057d933f8c9ea77f48b48abcf954c6f18c6b1cef236ac85e16fad4acab3f752-d_640x360?region=us",
    "url": "https://vimeo.com/1133357728"
  },
  {
    "id": 1133356681,
    "title": "1103_KPA_Lesson7",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077928327-0f4d2c848d9c2d47d60b48efcb727459009b6e94de2d5864733b8b5b3b54dc36-d_640x360?region=us",
    "url": "https://vimeo.com/1133356681"
  },
  {
    "id": 1133356383,
    "title": "1103_KPA_Lesson6",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077926986-a35407cd74cb866ba17f44f5a8190bad0f196c4763266f0e1c441587d1a5d14d-d_640x360?region=us",
    "url": "https://vimeo.com/1133356383"
  },
  {
    "id": 1133356023,
    "title": "1103_KPA_Lesson5",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077926618-d669f4e1233ee327b0a888ecfea69cfc2492d995901a4dde01deae2ee2bf38c2-d_640x360?region=us",
    "url": "https://vimeo.com/1133356023"
  },
  {
    "id": 1133355685,
    "title": "KPA_Lesson4",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077926108-83e2dd17827512288e799d5444fe109a97b66a4cb8579c53a19523a24cbafdea-d_640x360?region=us",
    "url": "https://vimeo.com/1133355685"
  },
  {
    "id": 1133355362,
    "title": "KPA_Lesson3",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077925697-a625a1b9af48c30a7ac2181f27dd23848e9d029f42040c297b04f40b9410658b-d_640x360?region=us",
    "url": "https://vimeo.com/1133355362"
  },
  {
    "id": 1133337375,
    "title": "KPA_Lesson1",
    "thumbnail_large": "https://i.vimeocdn.com/video/2077906276-503a41eaeef76b06e54babda85c3601a54e1ba14d43d971455b0275794d633b5-d_640x360?region=us",
    "url": "https://vimeo.com/1133337375"
  },
  {
    "id": 1124083840,
    "title": "연구 생활 레벨업! 대학원생 젬스터의 생산성 높이는 Gemini 활용법 (Feat. Deep Research & NotebookLM)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2065842509-74f6e92992c72d89e482490031c1e118bd72478f37eb03b5e805fd39241229ad-d_640x360?region=us",
    "url": "https://vimeo.com/1124083840"
  },
  {
    "id": 1124083554,
    "title": "원어민 수업 걱정 끝! 한국 토종 젬스터의 영어 자신감 키우는 Gemini 활용 꿀팁 (Feat. Gemini Live & Canvas)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2065842569-0d9d5fd42f11bb8e035e274e69c45a768822c7e05ca46192f407284b96f2b86a-d_640x360?region=us",
    "url": "https://vimeo.com/1124083554"
  },
  {
    "id": 1124083477,
    "title": "크리에이티브 레벨업! 광고 CD가 알려주는 크리에이티브하게 Gemini 쓰는 방법 (Feat. Veo3 & 나노바나나)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2065842073-de81f8fe87339d65a5f0207e1476b5d5d5f27e052f81f9c2fd73c102bece9451-d_640x360?region=us",
    "url": "https://vimeo.com/1124083477"
  },
  {
    "id": 1123154203,
    "title": "다이너마이트처럼 화려했던 EWC의 시작과 끝, 젠랑이와 함께!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064723635-791918a306a89bcce243ade9c384778ce4a8b22d064efc7bb1c65aa46639f461-d_640x360?region=us",
    "url": "https://vimeo.com/1123154203"
  },
  {
    "id": 1123149867,
    "title": "젠랑이가 알려주는 EWC 1분 뉴스! - EWC BREAKING NEWS Week 5!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064718462-c35763dbc616c75f77803f88c5136931bd69684ed890c723d549d8c4acaa3807-d_640x360?region=us",
    "url": "https://vimeo.com/1123149867"
  },
  {
    "id": 1123145746,
    "title": "바삭한 알베이크 치킨 먹방 가보자랑! - EWC 엠베서더 젠랑이의 사우디 국민 치킨 먹방!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064713663-e400c4cc7b4feccc57d6371df1a9775dcee798a1f11ace9c4ec5587b12b4aae7-d_640x360?region=us",
    "url": "https://vimeo.com/1123145746"
  },
  {
    "id": 1123141376,
    "title": "왕 젠랑이 보러 올 사람-",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064708326-ab8011ed3921fd2b555af7cd0278776f8bf935253639c5c4981202e7fd208e94-d_640x360?region=us",
    "url": "https://vimeo.com/1123141376"
  },
  {
    "id": 1123140440,
    "title": "인스파이어 멀어서 오히려 좋아-",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064707278-30ddb1259c21c9197caab75d51c1711de7c6168b6257008b7050cdd7177c39cd-d_640x360?region=us",
    "url": "https://vimeo.com/1123140440"
  },
  {
    "id": 1123139616,
    "title": "_ EWC 티켓 할인 코드 GENG15 쓰고 할인 받기! 괜찮아. 딩딩딩딩딩 젠지가 있잖아",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064706246-391b4113eac7f15bb4103d5afcaee32038a6c2bafcebbe41a4d7be4ff4e02941-d_640x360?region=us",
    "url": "https://vimeo.com/1123139616"
  },
  {
    "id": 1123137551,
    "title": "EWC 1분 뉴스 - BREAKING NEWS Week 4",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064703696-9bec814a8f27091c8782e11e66c6a69debf1d17edf5730d2f879c1a319a0c7cd-d_640x360?region=us",
    "url": "https://vimeo.com/1123137551"
  },
  {
    "id": 1123136607,
    "title": "EWC 앰베서더 젠랑이의 소다팝 댄스 챌린지!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064702633-f3fc9fdd7c3da77838fe4a3a74f5c83a363d53e361852c255e85ec6e372b035d-d_640x360?region=us",
    "url": "https://vimeo.com/1123136607"
  },
  {
    "id": 1123135399,
    "title": "EWC 2025 성황리 종료, 그리고 국가대항전 ENC 대공개-! EWC 앰베서더 젠랑이의 마지막 뉴스!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064701182-2f0e2e5f50b332b97ac9f0b0f68c32e305cc33b64acd063f81a919c2e203f6fb-d_640x360?region=us",
    "url": "https://vimeo.com/1123135399"
  },
  {
    "id": 1123135162,
    "title": "BLACKPINK - '뛰어(JUMP)' 커버 댄스 - EWC 앰배서더 젠랑이의 이스포츠 월드컵 폐막 공연!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064700901-97c79e52ac1fb2ee86a52b989c58b09bd6d1518d5e70f1cdfb172e90ec9c1aa7-d_640x360?region=us",
    "url": "https://vimeo.com/1123135162"
  },
  {
    "id": 1123122455,
    "title": "EWC 티켓 예매 방법 - EWC 엠버서더 젠랑이가 알려주겠다랑!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064685594-5a264242229311a200309cf88eaf45221bc845215f485e207b51ce95436fb755-d_640x360?region=us",
    "url": "https://vimeo.com/1123122455"
  },
  {
    "id": 1123122268,
    "title": "이번엔 배그랑 로켓리그다! EWC 6주차 뉴스, EWC 엠버서더 젠랑이가 알려주겠다랑!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064685509-fad2904d1204bff829bf4eeadad0d36654315330329992b87889f2f445398c7d-d_640x360?region=us",
    "url": "https://vimeo.com/1123122268"
  },
  {
    "id": 1123119862,
    "title": "왜 다른 팀 마스코트들이랑 계속 플러팅해- - EWC 엠베서더 젠랑이와 함께하는 Q&A 시간!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064682871-3ae9e814268c04df53468fb4b78d40def172bd35f1048c4043d7f63a49d9adda-d_640x360?region=us",
    "url": "https://vimeo.com/1123119862"
  },
  {
    "id": 1123119529,
    "title": "경기 전 당충전 필수! - 젠랑이가 사우디의 달콤 폭팔 디저트와 음료를 소개해 주겠다랑!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064682389-2a2e32705c75e48cab9c56ba55659b390e174ccbc388f768259940b4e0ddd214-d_640x360?region=us",
    "url": "https://vimeo.com/1123119529"
  },
  {
    "id": 1123119116,
    "title": "젠지 롤 형아들 PICK 메뉴 젠랑이가 다 먹어봤다랑! - EWC 앰베서더 젠랑이와 함께하는 GGX 스페셜 메뉴 먹방!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064681738-e9f2ec66eade58656e893881fa3f9c00310b36969fac2edb447c0df2a9151d08-d_640x360?region=us",
    "url": "https://vimeo.com/1123119116"
  },
  {
    "id": 1123118625,
    "title": "사자 보이즈 (Saja Boys) - 'SODA POP' by GenRang - EWC 앰베서더 젠랑이의 댄스 챌린지!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064681126-81ec4fb517385bc045ac9972a0bc38df7334bcb48eafd05b7e907017604dc5fa-d_640x360?region=us",
    "url": "https://vimeo.com/1123118625"
  },
  {
    "id": 1123118064,
    "title": "젠지, 금은동 메달 컬렉션 완성! EWC 7주차 뉴스, EWC 앰베서더 젠랑이가 알려주겠다랑!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064680523-397ec49c0cd72df0405505d89b51adb19bac99cd2d93e709856a0628f9973ed1-d_640x360?region=us",
    "url": "https://vimeo.com/1123118064"
  },
  {
    "id": 1123117130,
    "title": "BLACKPINK - '뛰어(JUMP)' Dance Cover by GenRang - EWC 앰배서더 젠랑이의 이스포츠 월드컵 폐막 공연!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064679297-937f31b2b49b56f673809feed083cfd341f9f531cc4704681b0972277afe2b38-d_640x360?region=us",
    "url": "https://vimeo.com/1123117130"
  },
  {
    "id": 1123116937,
    "title": "BTS (방탄소년단) - 'Dynamite (다이너마이트)' Dance Cover by GenRang - EWC 마지막 날, 젠랑이와 함께하는 축제 피날레!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064679016-a0772c31d192b400221a068df9e27bddd0e3f8aca83a5a2f4f8d35357603884d-d_640x360?region=us",
    "url": "https://vimeo.com/1123116937"
  },
  {
    "id": 1123116055,
    "title": "[ASMR] 나랑 같이 몰래 캐니언 형아 책상 구경할래- - EWC 앰베서더 젠랑이의 ASMR",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064677869-3eb3c5f14f90a582b6a63b0a0896f0e6b586780e444c636a91ca26e40b711c04-d_640x360?region=us",
    "url": "https://vimeo.com/1123116055"
  },
  {
    "id": 1123114949,
    "title": "EWC 2025 성황리 종료, 그리고 국가대항전 ENC 대공개-! EWC 엠베서더 젠랑이의 마지막 뉴스!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2064676598-3789c7ffa24863fec76e6a77fa702ad4df12c2f6836df2908abc9b42877d3a86-d_640x360?region=us",
    "url": "https://vimeo.com/1123114949"
  },
  {
    "id": 1116356841,
    "title": "[롯데카드] 롯데백화점 x 롯데카드 한도 없는 5_ 할인",
    "thumbnail_large": "https://i.vimeocdn.com/video/2055956200-50d61b165930233ae707960affef28b248d89490fbc8b07fe1407903cdf34e3a-d_640x360?region=us",
    "url": "https://vimeo.com/1116356841"
  },
  {
    "id": 1109886865,
    "title": "[Not Dead Yet] 0624",
    "thumbnail_large": "https://i.vimeocdn.com/video/2047511739-72319eeaf60900c40a2ac306ab5c8e2d4c4fbfa794cd76a0ebf70c19d88b001a-d_640x360?region=us",
    "url": "https://vimeo.com/1109886865"
  },
  {
    "id": 1109251233,
    "title": "[LYN-린] 사라진 그녀, 시작된 모험_린 사전예약 중",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046725152-5ce4c17d06454fe6b182c6941cbb96483ff42adb93b42b20c181b7675635d4ba-d_640x360?region=us",
    "url": "https://vimeo.com/1109251233"
  },
  {
    "id": 1109251134,
    "title": "TIGERNATION은 티켓만 끊어! 귀가 셔틀은 Gen.G가 책임진다 Did you hear- FREE SHUTTLE--!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046725005-a8640c03d6dfe87c7d549bbd4fcea7ca0a496dc57b8db5cfcd2452040e1e3c42-d_640x360?region=us",
    "url": "https://vimeo.com/1109251134"
  },
  {
    "id": 1109228300,
    "title": "EWC03_Tour_Desert_250730",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046692818-4860539ec7e6322fd8a04945e2b9b4cee1f8d129cd21d284bed27d5ba620cea8-d_640x360?region=us",
    "url": "https://vimeo.com/1109228300"
  },
  {
    "id": 1109227033,
    "title": "Genrang_popup_Triple_Panorama",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046691007-ba207eb8b57953e01a2b6849b81aadd334e7125c297f81dd8e5b252a74e39955-d_640x360?region=us",
    "url": "https://vimeo.com/1109227033"
  },
  {
    "id": 1109011730,
    "title": "EWC14_Fantasy_250805",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046424857-8f15387b1e13deff79b8b20d1f36369ac103ed75aec1711f053c6a1bc9823a89-d_640x360?region=us",
    "url": "https://vimeo.com/1109011730"
  },
  {
    "id": 1109011069,
    "title": "EWC05_Culture_Hat_250801",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046424036-92275432602cbe3935439d85abc4d902b0218087fa9f9d2d2caf7b921e9ebc0c-d_640x360?region=us",
    "url": "https://vimeo.com/1109011069"
  },
  {
    "id": 1109010395,
    "title": "EWC07_Character_250810",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046423060-38bcc3d1127720135c1dc68213fda61c7293a4b0142b8731b7adf89ef4a69985-d_640x360?region=us",
    "url": "https://vimeo.com/1109010395"
  },
  {
    "id": 1109009535,
    "title": "EWC06_Tour_City_250730",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046422150-39e51f4a9924e3b5ecd6cc2549509d8385f7f66f790cd694d93296888c15e5db-d_640x360?region=us",
    "url": "https://vimeo.com/1109009535"
  },
  {
    "id": 1109008025,
    "title": "EWC09_Proverb_250810",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046421417-d9434b61ad8f218b1222d70add06ed12e2673be08bae0ffc5017db486c7a9729-d_640x360?region=us",
    "url": "https://vimeo.com/1109008025"
  },
  {
    "id": 1109007118,
    "title": "EWC08_Music_Box_250811",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046419304-f8bcae0e6384149ab919009da34ecf4cbd107fc5c48e069bf899a655d9ab6fcd-d_640x360?region=us",
    "url": "https://vimeo.com/1109007118"
  },
  {
    "id": 1108990374,
    "title": "0502_Genrang_GGX_final",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046399275-2b890d1dd4d151a8d7c3d7fb4261f21f6f165386fdb5e181899ae34105edf78d-d_640x360?region=us",
    "url": "https://vimeo.com/1108990374"
  },
  {
    "id": 1108986465,
    "title": "Full ver 모두의 다이닝! K Cultured 이탈리안 레스토랑 매드포갈릭_#매드포갈릭#오광TV#Oh_KwangTV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046394364-4231f52e2513b9e82bfc5c0954fc38b230d61bcdb86d4293fc99189550f29000-d_640x360?region=us",
    "url": "https://vimeo.com/1108986465"
  },
  {
    "id": 1108983986,
    "title": "MEOVV(미야오) - HANDS UP M-V",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046391326-85952bbdd262b6d17016b86065a5518c41781a97142e05b428c53abf977e107e-d_640x360?region=us",
    "url": "https://vimeo.com/1108983986"
  },
  {
    "id": 1108983749,
    "title": "JEON SOMI (전소미) - 'XOXO' M-V",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046391715-376b21f1a88169df53ba502e451ffc947a5b6390fea11c5ac224e91da7526c3f-d_640x360?region=us",
    "url": "https://vimeo.com/1108983749"
  },
  {
    "id": 1108962309,
    "title": "2023-07-H-PORT(Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2046364487-2595c8b5f591f3c921cec9d4711455fd85072cad5d6680b7e7d0a63505b9f9b3-d_640x360?region=us",
    "url": "https://vimeo.com/1108962309"
  },
  {
    "id": 1098741264,
    "title": "[메이플스토리M] 신규 캐릭터 「아이엘(IEL)」 Full ver.  I 운명의 빛을 이끄는 자",
    "thumbnail_large": "https://i.vimeocdn.com/video/2033457233-dd4f8ab5f501830a89effcb00de386ea203d40abd8ffff7fcbe68edae0009bfa-d_640x360?region=us",
    "url": "https://vimeo.com/1098741264"
  },
  {
    "id": 1094901930,
    "title": "Oera | Brand Story",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028579290-3eeee2e24e24451287836674e3f8c7e5e9ddcacef0065c05bd611b84116590f2-d_640x360?region=us",
    "url": "https://vimeo.com/1094901930"
  },
  {
    "id": 1094900748,
    "title": "Opening Title l 고요의 바다",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028577215-e144197c706d1dfddf8905eb1f4ab5cb51bc47ae7a373c3ea0defed2351a4b04-d_640x360?region=us",
    "url": "https://vimeo.com/1094900748"
  },
  {
    "id": 1094685160,
    "title": "Kingdom Title",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028306259-099065e8f38be2bef7986ee7207f784e7aa8b11e12f44f57baac4edf232816a9-d_640x360?region=us",
    "url": "https://vimeo.com/1094685160"
  },
  {
    "id": 1094683558,
    "title": "Hyundai Card dive",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028303333-515cbb01e0d13947f0d064d2d81f0b445c1bf2fadffa6c3436c44115b28f16cc-d_640x360?region=us",
    "url": "https://vimeo.com/1094683558"
  },
  {
    "id": 1094682750,
    "title": "blade and soul revolution 30 dir",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028301463-5d7c793b45535e71f9f63e30a1dd64b367c58f81a6d9e3ae829c29d0f1f1c4e9-d_640x360?region=us",
    "url": "https://vimeo.com/1094682750"
  },
  {
    "id": 1094664298,
    "title": "2023-11-H-PORT(Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028280113-4578a731067dd42384cfc8af0719f0bf257aaa4aa9e33d6f459df059a142d521-d_640x360?region=us",
    "url": "https://vimeo.com/1094664298"
  },
  {
    "id": 1094661582,
    "title": "2024-Signature(Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028276666-e894a20e6fcde0ec6e154cedb5aa8cc7775e9facce60aa4ec35ff980155342f0-d_640x360?region=us",
    "url": "https://vimeo.com/1094661582"
  },
  {
    "id": 1094659003,
    "title": "2024-Showreel(Fin1080)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2028272691-22ccd72ca1465e6447da80ee4359ed3d9a9907233b1f6bc2b6e81af14d33f8ba-d_640x360?region=us",
    "url": "https://vimeo.com/1094659003"
  },
  {
    "id": 1094272087,
    "title": "ARTBEAT 'MAGIC' MV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828751-c8c4e7bb5beb20d84055f1f2106027eb85de4429ca9116a1c68a3ec273b446e0-d_640x360?region=us",
    "url": "https://vimeo.com/1094272087"
  },
  {
    "id": 1094269845,
    "title": "X-ARA ‘Hitchhiker’ M/V",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828317-c2392ee9acc960c1ac0209af50a76762a4092a8510431c1fbc19979f4cb2e2eb-d_640x360?region=us",
    "url": "https://vimeo.com/1094269845"
  },
  {
    "id": 1094268544,
    "title": "Again, my place MV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828041-4a10d1d2bbf211364beb7e56d0de773714dc32581128c99e0f18e1e02ee72b95-d_640x360?region=us",
    "url": "https://vimeo.com/1094268544"
  },
  {
    "id": 1094267270,
    "title": "AKMU Lee Suhyun 'Alien' MV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027827519-c88d3edc93f74f6def9f0ac61726921d133ceaf734463bdc4624d964513c7668-d_640x360?region=us",
    "url": "https://vimeo.com/1094267270"
  },
  {
    "id": 1094255137,
    "title": "STAYC 'ASAP' MV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027826528-2f01803ecc57b0cd0068d286fd9855252f48ba8abe4d3ac07b03b61ffb0bf561-d_640x360?region=us",
    "url": "https://vimeo.com/1094255137"
  },
  {
    "id": 1094249885,
    "title": "Heize - 'Undo' MV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027826201-7d38216bc8f0afc070e64d5d25facdd59081c76dd98edc64cc56e796fd4a65eb-d_640x360?region=us",
    "url": "https://vimeo.com/1094249885"
  },
  {
    "id": 1094247166,
    "title": "SOMI 'DUMB DUMB' MV",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027825904-2060f731ea33c794a802fc1ceaa9a7ab34e1cb4b5bb1d8209a84f89f1acadf08-d_640x360?region=us",
    "url": "https://vimeo.com/1094247166"
  },
  {
    "id": 1093918040,
    "title": "프리스트 | 오프닝 타이틀",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027798465-afa153bfaa2ec125d5cdf69fc60601f34735d59d0121f728088097451ee593e3-d_640x360?region=us",
    "url": "https://vimeo.com/1093918040"
  },
  {
    "id": 1093917691,
    "title": "공작도시 | 오프닝 타이틀",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027798705-c69a448a9cc9445f960a368a7e61e9fa63a35795a03273785a75bf01904ca42c-d_640x360?region=us",
    "url": "https://vimeo.com/1093917691"
  },
  {
    "id": 1093917472,
    "title": "괴이 | 오프닝 타이틀",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027798996-d4f1300e3bfb3b26d4011c39823545b7b4513d6f64f70a921407e35e5a8dde7d-d_640x360?region=us",
    "url": "https://vimeo.com/1093917472"
  },
  {
    "id": 1093916900,
    "title": "메이플스토리M  「에릴라이트」헬리아의 빛, 그리고 어둠",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027829241-79e3372fdd7bf037f8537f8c0449d6808a65b30533726f7dd358bdaad71c7f64-d_640x360?region=us",
    "url": "https://vimeo.com/1093916900"
  },
  {
    "id": 1093916618,
    "title": "메이플스토리M 「에릴라이트」빛의 숙명이 깃든창",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828548-728d3eca9209a2145c73a7719ab57724d18f5efb8f4f275d61bdbe74e86c48d5-d_640x360?region=us",
    "url": "https://vimeo.com/1093916618"
  },
  {
    "id": 1093916322,
    "title": "메이플스토리 「아즈모스 협곡」 (2024 썸머 쇼케이스-마일스톤)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027379486-9f941bd74f6bf0724f5b11cb7e15ad05bf30b8d618a39bea26c5fad359fd40b6-d_640x360?region=us",
    "url": "https://vimeo.com/1093916322"
  },
  {
    "id": 1093915935,
    "title": "‘음양사’  New SP 식신 광란의 슈텐도지",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828935-76d982415e7bdbfe9466ec758ab763cc4fee7468a07ecf1c28200f6078c35d18-d_640x360?region=us",
    "url": "https://vimeo.com/1093915935"
  },
  {
    "id": 1093915637,
    "title": "[LYN/린] Hello, Stranger?_Full ver.",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828442-163b358451efeb4e5bda109c1de411a0684cff5a61d2ab4c1c1aa0e46e90e509-d_640x360?region=us",
    "url": "https://vimeo.com/1093915637"
  },
  {
    "id": 1093915172,
    "title": "라인게임즈 | 이카루스 티저",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027829154-34d35c523a408611a4f7ada8e45818d8ce4445a42df7488b6c4bb43cce516b85-d_640x360?region=us",
    "url": "https://vimeo.com/1093915172"
  },
  {
    "id": 1091719684,
    "title": "[SCS] ESS TMS",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027828118-6722e801f47744236512c704649b3817a2b8a2747e077cc31fa097e24e36c478-d_640x360?region=us",
    "url": "https://vimeo.com/1091719684"
  },
  {
    "id": 1091719405,
    "title": "[SCS] Data Center Cooling",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024628555-b310a5fa942a950acc2ace91502e69359669e98d8835b29f27bb7956263f037d-d_640x360?region=us",
    "url": "https://vimeo.com/1091719405"
  },
  {
    "id": 1091719120,
    "title": "[SCS] Battery TMS",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027827949-918dc8ee6ad7c9bdef5743f2523f08bc815440730c52ad7e1d6b5ce758e24837-d_640x360?region=us",
    "url": "https://vimeo.com/1091719120"
  },
  {
    "id": 1091718868,
    "title": "[Nuna] Admin TEST",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024627930-4f231870e49cf3bb38712ac7c18b2ab811562cf8df79f874e3f04cbfe818a289-d_640x360?region=us",
    "url": "https://vimeo.com/1091718868"
  },
  {
    "id": 1091718475,
    "title": "soofe'e_brand_story (1080p)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027811203-f30d9d4545a609b4aed0a1a7ddb069d76fff4c6d5b2480f6ac8c65957647458c-d_640x360?region=us",
    "url": "https://vimeo.com/1091718475"
  },
  {
    "id": 1091718151,
    "title": "강원 랩소디 | 양양&삼척편",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024627319-7097e0f1e17bd4c28478b38c7e6ce82f951d673796ebee364e1eef4765b17a15-d_640x360?region=us",
    "url": "https://vimeo.com/1091718151"
  },
  {
    "id": 1091717900,
    "title": "교촌 | 함께 30주년",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027811522-a4f98a3c64ae99aa36ae12095e4ade258e702568666a51d36ed2d0170be9a044-d_640x360?region=us",
    "url": "https://vimeo.com/1091717900"
  },
  {
    "id": 1091717520,
    "title": "삼성 | 2023 Neo QLED 4K",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024626434-1e1c2dc6b6ffca3e3540d778ccfb692d0f23eb72504ac959f25bae2f572cfdca-d_640x360?region=us",
    "url": "https://vimeo.com/1091717520"
  },
  {
    "id": 1091714612,
    "title": "KT | 스카이라이프",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027811090-75ac417b22ca040789f7196c295ae738a2f89c0d0f428ab46004c4535e6906b3-d_640x360?region=us",
    "url": "https://vimeo.com/1091714612"
  },
  {
    "id": 1091713800,
    "title": "삼성 | 비스포크 - 시간을 비스포크하다 (Director ver.)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027827753-6ed5de9037e9a32272100a007896bbb4deae28df4ce99fbe8e1fc88755c18068-d_640x360?region=us",
    "url": "https://vimeo.com/1091713800"
  },
  {
    "id": 1091713370,
    "title": "Dive Into Diversity with 제주맥주",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810954-76f36f191ce19b46eb778b624d0473e920e0ab748dc62e0e8d0c1113ecfb546a-d_640x360?region=us",
    "url": "https://vimeo.com/1091713370"
  },
  {
    "id": 1091712619,
    "title": "강원 랩소디 | 원주편",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024620618-766c5f66d09ad991058875a6723a374782698f798da4affc4074dcce3f44507f-d_640x360?region=us",
    "url": "https://vimeo.com/1091712619"
  },
  {
    "id": 1091712386,
    "title": "강원 랩소디 | 춘천편",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027811392-11f2f8516dfe8edff0b35d3a8f6a194cb50203267cce3003b80bb9884019c29c-d_640x360?region=us",
    "url": "https://vimeo.com/1091712386"
  },
  {
    "id": 1091712090,
    "title": "기아 | 모하비",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027827013-5fc0cbd0c79c6ef9287508984109e51b6a847210c53f12f3f8128e102be57085-d_640x360?region=us",
    "url": "https://vimeo.com/1091712090"
  },
  {
    "id": 1091711901,
    "title": "르꼬끄 스포티브 | 드래곤로이",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024618988-e18232eae0a3b567479f89413273e0829540e3c5707d4649f42a769e6a3d1115-d_640x360?region=us",
    "url": "https://vimeo.com/1091711901"
  },
  {
    "id": 1091711726,
    "title": "리디북스 상수리 나무 아래 편",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024618740-a7b85d013289d79b3236f0deba74d0914b71c6a259df68a33f06a5f68ce30d02-d_640x360?region=us",
    "url": "https://vimeo.com/1091711726"
  },
  {
    "id": 1091710804,
    "title": "[삼성] CES 2021  Better Normal for All  | 인트로 애니메이션",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810835-c799b767c8c6f05639f5bdee83c37505dd7c5d0a8de72cafaeb23c3f09d5cab4-d_640x360?region=us",
    "url": "https://vimeo.com/1091710804"
  },
  {
    "id": 1091710357,
    "title": "동아오츠카 | 나랑드사이다",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027827263-2e6b9794f0a6f3f2d5ed64fcbba6875f65e0eae2d8a5e5d9c4b69c22d4453563-d_640x360?region=us",
    "url": "https://vimeo.com/1091710357"
  },
  {
    "id": 1091706643,
    "title": "Mad for Garlic 30s",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027807719-e4864799dd2aac86e22c392cb86a9c9716adc07fd4f5305c9f2e20b51f0f52a8-d_640x360?region=us",
    "url": "https://vimeo.com/1091706643"
  },
  {
    "id": 1091706624,
    "title": "Everytime 정관장 for a healthier life",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611943-d3254926f7b14e6015635da68029d50f0f49c5374ee70f01d6697e9fd75a5e4a-d_640x360?region=us",
    "url": "https://vimeo.com/1091706624"
  },
  {
    "id": 1091706618,
    "title": "[현대해상]  TVCF 간편건강보험 '유병자의 능력' 편",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027807534-45e268cca914f91da2f77f7039f994bcd0655cab8794081a81974e949826359b-d_640x360?region=us",
    "url": "https://vimeo.com/1091706618"
  },
  {
    "id": 1091706597,
    "title": "오에라 | 브랜드스토리",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027805451-49ebb7fc68dfd1db578729a2bff4f046523f21e3dabf85c48ea52e2152c3f26f-d_640x360?region=us",
    "url": "https://vimeo.com/1091706597"
  },
  {
    "id": 1091706586,
    "title": "HD현대 | 신입사원 모집",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611898-660babfce7deb3c9d299436ca5e49e610436a66879a9fefb9ae8a6b140f0ab8f-d_640x360?region=us",
    "url": "https://vimeo.com/1091706586"
  },
  {
    "id": 1091706574,
    "title": "SSF SHOP | 역대급 이벤트 진행중",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027805172-7d1909e5da0e9784a6ee5db3f6270fa0544df5f908c5f60d408594fc0e65bc7b-d_640x360?region=us",
    "url": "https://vimeo.com/1091706574"
  },
  {
    "id": 1091706563,
    "title": "SSF SHOP | 슈퍼딜",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027804843-e78c0fe01ababc84c1443438f168296d4e01f8bb55f327188e72a0bd27f5a9b3-d_640x360?region=us",
    "url": "https://vimeo.com/1091706563"
  },
  {
    "id": 1091706551,
    "title": "SSF SHOP | 아우터페스티벌",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027804710-cefdbcfdadbf64dd5fc85100f396d35f498b0d351f080539a723748574dc55ea-d_640x360?region=us",
    "url": "https://vimeo.com/1091706551"
  },
  {
    "id": 1091706545,
    "title": "삼성 갤럭시 A | AWESOME is for Everyone × BLACKPINK",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810206-20e960245e85c365ea422d67f4b131b3556969fad650d58565a238fa17aa95a9-d_640x360?region=us",
    "url": "https://vimeo.com/1091706545"
  },
  {
    "id": 1091706519,
    "title": "하우빌드와 건축하세요!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810514-a9187b9f04aa6aab9ed095b86fd1b2eeea66464459be4500384f09b9faca0f60-d_640x360?region=us",
    "url": "https://vimeo.com/1091706519"
  },
  {
    "id": 1091706477,
    "title": "[롯데리아] 땡스버거 | 고마운 사람에게 마음을 전하세요",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611759-d3ff6c161b3584c5c82f1848f3ed4f4bd814919b7e93e6f892fe13399c5d4afc-d_640x360?region=us",
    "url": "https://vimeo.com/1091706477"
  },
  {
    "id": 1091706463,
    "title": "네이버 쇼핑라이브 1주년",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611706-5ef9648d3ac34d76020fbea35463ae60af75bc8758ded3864891d825e625d2a3-d_640x360?region=us",
    "url": "https://vimeo.com/1091706463"
  },
  {
    "id": 1091706443,
    "title": "락피도 | 적기영양",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810088-f372e93473ca562d2f2b170758e25a8b11cdc82b73efdf851dedbcd77a8e9735-d_640x360?region=us",
    "url": "https://vimeo.com/1091706443"
  },
  {
    "id": 1091706411,
    "title": "롯데카드 | 로카머니",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611629-7c6cacfa226f0e205c77032a757a45d4a8055763f91923421a22d3db3f898daf-d_640x360?region=us",
    "url": "https://vimeo.com/1091706411"
  },
  {
    "id": 1091706391,
    "title": "스타벅스 현대카드 ‘리마’",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611585-6d0adb620ae9df976e9d6ac46f967795843a4d202424a48c13a7a2bd469d9808-d_640x360?region=us",
    "url": "https://vimeo.com/1091706391"
  },
  {
    "id": 1091706362,
    "title": "[불스원샷] 엔진때 싹!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027807407-e9e443644ba7859410bf791945883d4b42acfc57218654eddbd7040b5787b1b8-d_640x360?region=us",
    "url": "https://vimeo.com/1091706362"
  },
  {
    "id": 1091706338,
    "title": "NH농협 | 아이들의 미래 농촌편",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027807861-833ed39749023368bc675ea715fee9142c36db6b8459e4ebe77eb62b74da814d-d_640x360?region=us",
    "url": "https://vimeo.com/1091706338"
  },
  {
    "id": 1091706315,
    "title": "[Galaxy S24 Ultra] Watch6  Ecosystem Film | SAMSUNG",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027806779-39158dd8bac5102736a097935d35f8d8d989be79af849951368486fef33e013c-d_640x360?region=us",
    "url": "https://vimeo.com/1091706315"
  },
  {
    "id": 1091706202,
    "title": "현대 컨티뉴 | 꿈을 위한 여정",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027557834-37b0f8a107b4c6fb2bc907eaf3c515639b0d6b81f9375208e0019c9c71f7a6eb-d_640x360?region=us",
    "url": "https://vimeo.com/1091706202"
  },
  {
    "id": 1091706179,
    "title": "삼성 갤럭시 S10 | Wallpaper Film",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810298-43d8e8d77bf4e0b367222b2b00419db013593fe773e01bd315f861e03f957707-d_640x360?region=us",
    "url": "https://vimeo.com/1091706179"
  },
  {
    "id": 1091706170,
    "title": "SK holdings의 사회적 가치는 뭐예요? (ver.1)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027808020-ba03ac248b285b28a3a5e877f85d441f598ee64cf32abb3a22172513a4baf9ce-d_640x360?region=us",
    "url": "https://vimeo.com/1091706170"
  },
  {
    "id": 1091706155,
    "title": "SK holdings의 사회적 가치는 뭐예요? (ver.2)",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027808867-6dbfcf153334cd0feea38b0d1bae5af494d5a8005fe7f04d65b5d99bfae689a2-d_640x360?region=us",
    "url": "https://vimeo.com/1091706155"
  },
  {
    "id": 1091706130,
    "title": "삼성화재다이렉트 | 운전자보험",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024611230-3eaa7d44c41fba9d3739a65a270e246892baa062648cf1fe58556977a82a6770-d_640x360?region=us",
    "url": "https://vimeo.com/1091706130"
  },
  {
    "id": 1091706044,
    "title": "SK 하이닉스 | 세상을 바꿀 반도체",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027809844-23d366a13575bfdd4c5d69dfdd1249a373e17b88f1b9182ea84fc1851ab48982-d_640x360?region=us",
    "url": "https://vimeo.com/1091706044"
  },
  {
    "id": 1091705925,
    "title": "[다우니] 7일간 피어나는 향수 컬렉션",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024610942-03b009ff275b644b033cb93ba61ea46d7c6c4387bd11e840a9822c584fa8925e-d_640x360?region=us",
    "url": "https://vimeo.com/1091705925"
  },
  {
    "id": 1091705894,
    "title": "[다우니] 7일간 피어나는 향수 컬렉션 | 건조기 사용 후에도 향이 오래오래!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024610906-adafea37954451d393105cb013c7ddcf928765b9406da021e9290368c0dd93de-d_640x360?region=us",
    "url": "https://vimeo.com/1091705894"
  },
  {
    "id": 1091705866,
    "title": "[맥심] 슈프림골드 | 진하게 부드럽게 라떼처럼 즐겨봐!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027807108-7d77dd830d0947ededcdf140aec1c118acb20718bc2563bd5ac9d928e7582710-d_640x360?region=us",
    "url": "https://vimeo.com/1091705866"
  },
  {
    "id": 1091705860,
    "title": "[제일파프] 바쁘다 바빠 현대사회! 통증엔 펭귄이 제일이지",
    "thumbnail_large": "https://i.vimeocdn.com/video/2027810714-3d9ac3f836c10629e42b0ac053ee1909a3f9f0c1e99e5a2582fa4e14b8509439-d_640x360?region=us",
    "url": "https://vimeo.com/1091705860"
  },
  {
    "id": 1091705693,
    "title": "아웃백과 여름엔 당연히 맵고 시원한 ‘맵시’ 페어링으로!",
    "thumbnail_large": "https://i.vimeocdn.com/video/2024610649-6ef9599bd903ed7175515efcc72b1de5a785ca3c1de42b594c5702327bc70352-d_640x360?region=us",
    "url": "https://vimeo.com/1091705693"
  }
];
